// All permissions for this module.
// Example of the constant:
// export const EXAMPLE_PERM = "Perm Id"

export const SEE_GENERAL_ACCOUNTING_MODULE = 100;
export const SEE_GENERAL_ACCOUNTING_REPORTING_PAGE = 1004;
